module.exports = __webpack_public_path__ + "img/pinky_swear.svg";